import React from "react";
import { Layout, MyReferral } from "../components";

const MyReferralPage = () => {
  return (
    <>
      <Layout>
        <MyReferral />
      </Layout>
    </>
  );
};

export default MyReferralPage;
